import React from "react"

export default props => {
    const style = props.s == "duo" ? "fa-duotone" : "fa-" + (props.s || "duotone")
    const name = props.n || ""
    return(
        <i className={`${style} fa-${name} ${props.className || ""}`}/>
    )
}